import React, { useState } from "react";

export default function CustomerService() {
  const [isOpen, setIsOpen] = useState(false);
  const [input, setInput] = useState("");
  const [messages, setMessages] = useState([
    { sender: "bot", text: "Hai! Ada yang bisa saya bantu?" },
  ]);
  const [isLoading, setIsLoading] = useState(false);

  const sendMessage = async () => {
    if (!input.trim()) return;
    const newMessages = [...messages, { sender: "user", text: input }];
    setMessages(newMessages);
    setInput("");
    setIsLoading(true);

    try {
      const response = await fetch(
        "https://flowise-production-7f3e.up.railway.app/api/v1/prediction/ecb7fdc3-ce77-40b2-b3a9-ee28d7b1db77",
        {
          method: "POST",
          headers: {
            Authorization:
              "Bearer bxcIBfOM7bNbVMH8gl8zO_Nonam3VDv2tyCqk9E94Bs",
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ question: input }),
        }
      );

      const result = await response.json();
      const botReply =
        result?.text || "Maaf, saya tidak bisa memproses pertanyaan itu.";

      setMessages([...newMessages, { sender: "bot", text: botReply }]);
    } catch (error) {
      console.error("Error:", error);
      setMessages([
        ...newMessages,
        { sender: "bot", text: "Terjadi kesalahan saat menghubungi server." },
      ]);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="fixed bottom-6 right-6 z-50">
    <button
    onClick={() => setIsOpen(!isOpen)}
    className="w-14 h-14 rounded-full bg-blue-600 text-white flex items-center justify-center shadow-lg hover:bg-blue-700 transition-all"
    title="Chat Customer Service"
    >
    <svg
        xmlns="http://www.w3.org/2000/svg"
        className="w-7 h-7"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
        strokeWidth={2}
    >
        <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M7 8h10M7 12h6m5 8l-4-4H7a4 4 0 01-4-4V6a4 4 0 014-4h10a4 4 0 014 4v10a4 4 0 01-4 4z"
        />
    </svg>
    </button>

      {isOpen && (
        <div className="w-80 bg-white rounded-2xl shadow-2xl absolute bottom-20 right-0 flex flex-col overflow-hidden border border-gray-200 animate-fadeIn">
          <div className="bg-blue-600 text-white px-4 py-3 flex justify-between items-center">
            <span className="font-semibold">Customer Service</span>
            <button
              onClick={() => setIsOpen(false)}
              className="text-white hover:text-gray-200 text-lg font-bold"
            >
              ×
            </button>
          </div>

          <div className="flex-1 overflow-y-auto p-3 space-y-2 bg-gray-50 max-h-80">
            {messages.map((msg, i) => (
              <div
                key={i}
                className={`flex ${
                  msg.sender === "user" ? "justify-end" : "justify-start"
                }`}
              >
                <div
                  className={`px-3 py-2 rounded-xl text-sm ${
                    msg.sender === "user"
                      ? "bg-blue-600 text-white rounded-br-none"
                      : "bg-gray-200 text-gray-800 rounded-bl-none"
                  }`}
                >
                  {msg.text}
                </div>
              </div>
            ))}
            {isLoading && (
              <div className="flex justify-start">
                <div className="bg-gray-200 text-gray-700 text-sm px-3 py-2 rounded-xl animate-pulse">
                  Mengetik...
                </div>
              </div>
            )}
          </div>

          <div className="border-t border-gray-200 p-2 flex items-center bg-white">
            <input
              type="text"
              placeholder="Tulis pesan..."
              className="flex-1 p-2 rounded-lg border border-gray-300 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
              value={input}
              onChange={(e) => setInput(e.target.value)}
              onKeyDown={(e) => e.key === "Enter" && sendMessage()}
            />
            <button
              onClick={sendMessage}
              className="ml-2 bg-blue-600 text-white px-3 py-2 rounded-lg text-sm hover:bg-blue-700 transition"
            >
              Kirim
            </button>
          </div>
        </div>
      )}
    </div>
  );
}